/* BPS routine finder: curated products -> selected variants -> Shopify cart.
   Ported from the standalone BPS theme and wired into this theme's cart drawer. */
(() => {
  if (window.BPSRoutineInstalled) return;
  window.BPSRoutineInstalled = true;
  const groups = ['edges', 'braids', 'care'];
  const priorities = ['routine-finish', 'routine-refresh', 'routine-daily'];
  const questions = [
    ['What’s your next look?', ['Sleek edges & ponytails', 'Braids, twists & locs', 'Everyday hair care']],
    ['What matters most today?', ['A polished finish', 'A fresh-feeling routine', 'A simple daily lineup']],
    ['How much of a routine feels right?', ['Just one essential', 'A two-step pairing', 'The full three-step lineup']]
  ];
  let modal, content, config, previousFocus, step = 0, answers = [], selection = [], busy = false;
  let completed = false, reviewRequired = false;
  const el = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function button(text, handler, className = 'rq-option') {
    const node = el('button', text, className); node.type = 'button'; node.onclick = handler; return node;
  }
  function link(text, url, className = 'rq-link') {
    const node = el('a', text, className); node.href = url; return node;
  }
  function recommendations() {
    const seen = new Set();
    return (config.groups[groups[answers[0]]] || []).filter(p => {
      if (seen.has(p.id) || p.requiresSellingPlan || !p.variants.some(v => v.available)) return false;
      seen.add(p.id); return true;
    }).map((p, index) => ({p, index, match: p.tags.map(t => t.toLowerCase()).includes(priorities[answers[1]])}))
      .sort((a, b) => Number(b.match) - Number(a.match) || a.index - b.index)
      .slice(0, answers[2] + 1).map(x => x.p);
  }
  function title(text) {
    const heading = el('h2', text); heading.id = 'routine-title'; heading.tabIndex = -1;
    content.append(heading); heading.focus();
  }
  function render() {
    content.replaceChildren();
    if (step < 3) {
      content.append(el('p', `FIND YOUR KIND OF STRONG · ${step + 1} / 3`, 'rq-eyebrow'));
      title(questions[step][0]);
      const options = el('div', undefined, 'rq-options');
      questions[step][1].forEach((label, index) => options.append(button(label, () => {
        answers[step] = index; step++; render();
      })));
      content.append(options);
      if (step) content.append(button('← Back', () => { step--; render(); }, 'rq-back'));
      return;
    }
    title('YOUR PERSONAL EDIT.');
    const products = recommendations();
    selection = products.map(product => ({product, variant: product.variants.find(v => v.available), included: true}));
    if (!selection.length) {
      content.append(el('p', config.designMode
        ? 'Choose products under Routine quiz in the theme editor. Products must be available on the Online Store and support one-time purchases.'
        : 'No available products match this routine right now. Explore the collection for more options.'));
      content.append(link('Shop the collection', config.shop, 'btn btn-primary'));
    } else {
      content.append(el('p', ['Selected for a polished finish.', 'Selected for a refreshing routine.', 'Selected for everyday care.'][answers[1]] + ' Choose your sizes and keep only the products you want.'));
      if (selection.length < answers[2] + 1) content.append(el('p', `Only ${selection.length} matching product${selection.length === 1 ? ' is' : 's are'} available right now.`));
      const form = el('form'); form.id = 'routine-form';
      selection.forEach(item => {
        const card = el('div', undefined, 'routine-result');
        if (item.product.image) { const image = el('img'); image.src = item.product.image; image.alt = item.product.title; card.append(image); }
        const details = el('div');
        const label = el('label', undefined, 'routine-include');
        const check = el('input'); check.type = 'checkbox'; check.checked = true;
        check.onchange = () => { item.included = check.checked; updateButton(); };
        label.append(check, el('span', item.product.title)); details.append(label);
        details.append(link('Product details', item.product.url, 'routine-details'));
        const variantLabel = el('label', 'Size / option'); const select = el('select');
        select.setAttribute('aria-label', `Size or option for ${item.product.title}`);
        item.product.variants.forEach(v => {
          const option = el('option', `${v.title === 'Default Title' ? 'Standard' : v.title} — ${v.formattedPrice}${v.available ? '' : ' · Sold out'}`);
          option.value = String(v.id); option.disabled = !v.available; option.selected = v.id === item.variant.id; select.append(option);
        });
        select.onchange = () => { item.variant = item.product.variants.find(v => String(v.id) === select.value); updateButton(); };
        variantLabel.append(select); details.append(variantLabel); card.append(details); form.append(card);
      });
      const status = el('p'); status.id = 'routine-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); form.append(status);
      const add = el('button', 'Add my routine to bag', 'btn btn-primary'); add.type = 'submit'; add.id = 'routine-add'; form.append(add);
      form.onsubmit = addRoutine; content.append(form); updateButton();
      content.append(el('p', 'Prices and availability are confirmed by Shopify when added. Shipping, taxes and discounts are calculated at checkout.', 'routine-note'));
    }
    content.append(button('← Change answers', () => { if (!busy) { step = 2; render(); } }, 'rq-back'));
  }
  function updateButton() {
    const add = document.getElementById('routine-add'); if (!add) return;
    const count = selection.filter(x => x.included && x.variant.available).length;
    add.disabled = busy || completed || reviewRequired || count === 0;
    add.textContent = completed ? 'Added to your bag' : reviewRequired ? 'Check your bag before adding again' : busy ? 'Adding your routine…' : `Add ${count} product${count === 1 ? '' : 's'} to my bag`;
  }
  async function addRoutine(event) {
    event.preventDefault();
    if (busy || completed || reviewRequired) return;
    const items = selection.filter(x => x.included && x.variant.available).map(x => ({id: x.variant.id, quantity: 1}));
    if (!items.length) return;
    busy = true; updateButton();
    const status = document.getElementById('routine-status'); status.textContent = 'Adding your selected products…';
    const controls = [...modal.querySelectorAll('button,input,select')]; controls.forEach(x => x.disabled = true);
    const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const root = config.root.endsWith('/') ? config.root : config.root + '/';
      const response = await fetch(root + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items}), signal: controller.signal});
      let data; try { data = await response.json(); } catch { throw new Error('The cart response could not be confirmed.'); }
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify could not add the complete routine. Availability may have changed.');
      completed = true; status.textContent = 'Your selected products were added to your bag.';
      status.after(link('View bag & checkout ↗', config.cart, 'btn btn-primary'));
      // This theme has a cart drawer — refresh it and slide it open, then close the quiz.
      // Every step is optional; a failure here must never retry the add.
      try {
        if (typeof window.mmeRefreshCartBody === 'function') window.mmeRefreshCartBody();
        if (typeof window.openCartDrawer === 'function') { modal.close(); window.openCartDrawer(); }
        else if (typeof window.openCart === 'function') { modal.close(); window.openCart(); }
      } catch { /* drawer is a nicety, not a requirement */ }
      fetch(root + 'cart.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}}).then(r => r.ok ? r.json() : null).then(cart => {
        if (!cart) return;
        const badge = document.getElementById('cartBadge');
        if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
        const legacy = document.getElementById('bagCount');
        if (legacy) legacy.textContent = cart.item_count;
      }).catch(() => {});
    } catch (error) {
      reviewRequired = true;
      status.textContent = `${error.name === 'AbortError' ? 'The request timed out, so we could not confirm the cart.' : error.message} Please check your bag before trying again; some items may already have been added.`;
      status.after(link('Review my bag', config.cart, 'btn btn-primary'));
    } finally {
      clearTimeout(timeout); busy = false;
      // Keep selections locked after a request to prevent duplicate or uncertain adds.
      modal.querySelector('[data-close-routine]').disabled = false; updateButton();
    }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open-routine]')) {
      modal = document.getElementById('routine-modal'); content = document.getElementById('routine-content');
      if (!modal || !content || busy) return;
      previousFocus = event.target.closest('[data-open-routine]');
      if (!modal.dataset.eventsBound) {
        modal.addEventListener('cancel', e => { if (busy) e.preventDefault(); });
        modal.addEventListener('close', () => { document.body.style.overflow = ''; previousFocus?.focus(); });
        modal.dataset.eventsBound = 'true';
      }
      // Keep a successful/uncertain attempt visible for this page session.
      if (!completed && !reviewRequired) {
        try { config = JSON.parse(document.getElementById('routine-data').textContent); } catch {
          content.replaceChildren(); title('Routine finder unavailable'); content.append(el('p', 'Please refresh the page and try again.')); modal.showModal(); return;
        }
        step = 0; answers = []; modal.showModal(); render();
      } else modal.showModal();
      document.body.style.overflow = 'hidden';
    }
    if (event.target.closest('[data-close-routine]') && !busy) modal?.close();
  });
})();
